import { keyboardAction, KeyType } from "../../core/utils/keyboardActions";
import { styles } from "./SliderArrow.style";

export interface SliderArrowProps {
  onClick: () => void;
  direction: "left" | "right";
  ariaLabel: string;
  disabled?: boolean;
}

export const SliderArrow = (props: SliderArrowProps) => {
  const { onClick, direction, ariaLabel, disabled } = props;

  return (
    <div
      onClick={onClick}
      onKeyDown={(e) => keyboardAction(e, KeyType.ENTER, onClick)}
      className={styles.arrow(disabled)}
      role="button"
      aria-label={ariaLabel}
      aria-disabled={disabled}
      tabIndex={disabled ? -1 : 0}
    >
      <svg className={styles.icon()} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        {direction === "left" ? <polyline points="15 18 9 12 15 6" /> : <polyline points="9 18 15 12 9 6" />}
      </svg>
    </div>
  );
};
